import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-adhoc-activities-modal',
    templateUrl: './adhoc-activities-modal.component.html',
    styleUrls: ['./adhoc-activities-modal.component.scss']
})
export class AdHocActivitiesModalComponent {

    public title: string;
    public name: string = "";
    public originalName: string = "";
    public originalDuration: number = 0;
    public duration: number = 0;

    constructor(private instance: NgbActiveModal) { }

    public Cancel(reason: any) {
        this.instance.dismiss(reason);
    }

    public Save() {
        this.instance.close({
            activity: {
                activityName: this.name,
                duration: this.duration
            }
        });
    }

    public saveDisabled() {

        if (this.name === '' || this.duration === 0) {
            return true;
        }

        if (this.name === this.originalName) {
            return this.duration === this.originalDuration;
        }

        if (this.duration === this.originalDuration) {
            return this.name === this.originalName;
        }

        return false;

    }


}

